import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Box, TextField } from '@mui/material';
import MasterGrid from '../components/MasterGrid';
import DailyEntries from '../components/DailyEntries';

export default function Jobs() {
  const [uploads, setUploads] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [uploadId, setUploadId] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  // Load available uploads once on mount
  useEffect(() => {
    axios
      .get('/api/uploads/')
      .then(res => {
        setUploads(res.data);
        if (res.data.length) {
          const first = res.data[0];
          setSelectedDate(first.date);
          setUploadId(`${first.id}`);
        }
      })
      .catch(err => console.error('Failed to fetch uploads:', err));
  }, []);

  // When the user picks a date, update uploadId if that date exists
  const onDateChange = e => {
    const date = e.target.value;
    setSelectedDate(date);
    const match = uploads.find(u => u.date === date);
    setUploadId(match ? `${match.id}` : '');
  };

  // After any live Add/Remove in MasterGrid, bump this to re-fetch entries
  const handleToggle = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Jobs & Daily List
      </Typography>

      <Box mb={2}>
        <TextField
          label="Select Date"
          type="date"
          value={selectedDate}
          onChange={onDateChange}
          InputLabelProps={{ shrink: true }}
        />
      </Box>

      {uploadId ? (
        <>
          <MasterGrid uploadId={uploadId} onToggle={handleToggle} />
          <Box mt={4}>
            <DailyEntries
              uploadId={uploadId}
              refreshKey={refreshKey}
              uploadDate={selectedDate}
            />
          </Box>
        </>
      ) : (
        <Typography>No upload available for that date.</Typography>
      )}
    </Box>
  );
}
